// extracted by mini-css-extract-plugin
module.exports = {"tableWrap":"EnrolledClinics_tableWrap__2Ym-E","actionsCol":"EnrolledClinics_actionsCol__tFLFy"};